export default {
      id: "icon-calisma-masasi-usage",
      viewBox: "0 0 507.4 507.4",
      url: __webpack_public_path__ + "./icon/icons.svg#icon-calisma-masasi",
      toString: function () {
        return this.url;
      }
    }